var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('field-select-module',{attrs:{"board":this.board,"is-print":_vm.isPrint},model:{value:(_vm.form.stdInfo),callback:function ($$v) {_vm.$set(_vm.form, "stdInfo", $$v)},expression:"form.stdInfo"}}),_c('specific-health-exam-table',{attrs:{"board":_vm.board,"is-print":_vm.isPrint,"title":"특수건강진단 현황","tableData":[
      { id: 'input1', title: '부서명', type: 'text', default: _vm.form.stdInfo.section, readonly: true },
      { id: 'input2', title: '이름', type: 'text', placeholder: '입력' },
      {
        id: 'input3',
        title: '수검 여부',
        type: 'radio',
        selectData: ['수검', '미수검'],
        default: '미수검'
      },
      { id: 'input4', title: '미수검 사유', type: 'text', placeholder: '입력', visible: {input3: '미수검'} },
    ]},on:{"input":_vm.handleList},model:{value:(_vm.form.exam),callback:function ($$v) {_vm.$set(_vm.form, "exam", $$v)},expression:"form.exam"}}),_c('file-upload-module',{staticClass:"w-full mt-4",attrs:{"id":"fileList","is-print":_vm.isPrint,"readonly":_vm.board.readonly},model:{value:(_vm.form.fileList),callback:function ($$v) {_vm.$set(_vm.form, "fileList", $$v)},expression:"form.fileList"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }